import { CurrentWeather } from "../interfaces/CurrentWeather";

export const mockCurrent: CurrentWeather = {
	location: {
		name: "Sao Paulo",
		region: "Sao Paulo",
		country: "Brazil",
		lat: -23.53,
		lon: -46.62,
		tz_id: "America/Sao_Paulo",
		localtime_epoch: 1688131093,
		localtime: "2023-06-30 10:18",
	},
	current: {
		last_updated_epoch: 1688130900,
		last_updated: "2023-06-30 10:15",
		temp_c: 17,
		temp_f: 62.6,
		is_day: 1,
		condition: {
			text: "Partly cloudy",
			icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
			code: 1003,
		},
		wind_mph: 6.9,
		wind_kph: 11.2,
		wind_degree: 80,
		wind_dir: "E",
		pressure_mb: 1027,
		pressure_in: 30.33,
		precip_mm: 0,
		precip_in: 0,
		humidity: 72,
		cloud: 75,
		feelslike_c: 17,
		feelslike_f: 62.6,
		vis_km: 8,
		vis_miles: 4,
		uv: 5,
		gust_mph: 7.2,
		gust_kph: 11.5,
		air_quality: {
			co: 654,
			no2: 32.599998474121094,
			o3: 29.299999237060547,
			so2: 29.299999237060547,
			pm2_5: 17.299999237060547,
			pm10: 32,
			"us-epa-index": 2,
			"gb-defra-index": 2,
		},
	},
};
